import React from 'react'
import './index.sass'

export default function EmptyScreen({logo, heading, description, btntext, handleClick}) {
    return (
        <div className="empty-screen" id='empty-screen'>
            <div className="logo">
                <img src={require(`../../../assets/icons/${logo}.svg`)} />
            </div>
            <p className="heading">{heading}</p>
            <p className="description">{description}</p>
            { btntext ? <div className="button" onClick={handleClick} ><p>{btntext}</p></div> : ''}
        </div>
    )
}